export function wavelengthToColor(wlNm: number): number {
  let r = 0, g = 0, b = 0;
  let t: number;

  if (wlNm >= 400 && wlNm < 410) {
    t = (wlNm - 400) / 10;
    r = 0.33 * t - 0.20 * t * t;
  } else if (wlNm >= 410 && wlNm < 475) {
    t = (wlNm - 410) / 65;
    r = 0.14 - 0.13 * t * t;
  } else if (wlNm >= 545 && wlNm < 595) {
    t = (wlNm - 545) / 50;
    r = 1.98 * t - t * t;
  } else if (wlNm >= 595 && wlNm < 650) {
    t = (wlNm - 595) / 55;
    r = 0.98 + 0.06 * t - 0.40 * t * t;
  } else if (wlNm >= 650 && wlNm < 700) {
    t = (wlNm - 650) / 50;
    r = 0.65 - 0.84 * t + 0.20 * t * t;
  }

  if (wlNm >= 415 && wlNm < 475) {
    t = (wlNm - 415) / 60;
    g = 0.80 * t * t;
  } else if (wlNm >= 475 && wlNm < 590) {
    t = (wlNm - 475) / 115;
    g = 0.8 + 0.76 * t - 0.80 * t * t;
  } else if (wlNm >= 585 && wlNm < 639) {
    t = (wlNm - 585) / 54;
    g = 0.82 - 0.80 * t;
  }

  if (wlNm >= 400 && wlNm < 475) {
    t = (wlNm - 400) / 75;
    b = 2.20 * t - 1.50 * t * t;
  } else if (wlNm >= 475 && wlNm < 560) {
    t = (wlNm - 475) / 85;
    b = 0.7 - t + 0.30 * t * t;
  }

  const R = Math.round(Math.max(0, Math.min(1, r)) * 255);
  const G = Math.round(Math.max(0, Math.min(1, g)) * 255);
  const B = Math.round(Math.max(0, Math.min(1, b)) * 255);

  return (R << 16) | (G << 8) | B;
}
